import cardValidator from 'card-validator';
import { validateEmail, validateInternationalPostalCode } from '../../Shared/validations';
import { copyFor } from '../../../copy/copy';
import { PaymentMethod } from '../../../utils/enums';

const validateFullName = values => {
    if (!values) return;
    if (values.fullName == null || values.fullName === '') {
        return { fullName: copyFor('validationErrors', 'fullName', 'email') };
    }
    const split = values.fullName.split(' ');

    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName', 'email') };
};

const validateCard = values => {
    if (!values) return;
    if (values === 'bypass') return {};
    const creditCardValidation = cardValidator.number(values.cardNumber);
    if (!creditCardValidation.isValid) {
        return { cardNumber: 'Invalid Credit Card Number' };
    } else {
        if (
            creditCardValidation.card &&
            creditCardValidation.card.code &&
            creditCardValidation.card.code.size
        ) {
            const cvvValidation = cardValidator.cvv(
                values.cvv,
                creditCardValidation.card.code.size
            );

            if (!cvvValidation.isValid) {
                return { cvv: 'Invalid CVV' };
            }
        }
    }
    return {};
};

export const validateCvv = values => {
    if (!values) return;
    if (values === 'bypass') return {};
    const onlyNums = /^\d*$/;
    if (values.cvv == null || values.cvv === '' || onlyNums.exec(values.cvv) === false) {
        return { cvv: copyFor('validationErrors', 'cvv') };
    }
    return {};
};

const validateDate = values => {
    if (!values) return;
    if (values === 'bypass') return {};
    const dateValidation = cardValidator.expirationDate(values.expDate);
    if (!dateValidation.isValid) {
        return { expDate: 'Invalid Date' };
    }
    return {};
};

const validation = (values, props) => {
    if (!values) return;
    let errors = {
        ...validateInternationalPostalCode(values),
        ...validateEmail(values),
        ...validateFullName(values)
    };

    if (props.paymentMethod !== PaymentMethod.OrgHunter) {
        errors = {
            ...errors,
            ...validateDate(values),
            ...validateCard(values),
            ...validateCvv(values)
        };
    } else if (props.paymentMethod === PaymentMethod.OrgHunter) {
        errors = {
            ...errors,
            ...validateDate('bypass'),
            ...validateCard('bypass'),
            ...validateCvv('bypass')
        };
    }
    return errors;
};

export default validation;
